import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      

      let table = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, 0)`)

      if(this.title.display == 'Y') {
        table
        .append('text')
        .attr('id', `MAIN_TITLE_${this.localId}`)
        .attr('transform', `translate(0, ${this.title.main.y})`)
        .attr('font-size', this.title.main.tSize).attr('fill', this.title.main.tColor)
        .text('A-ITRs Status')

        table
        .append('text')
        .attr('id', `SUB_TITLE_${this.localId}`)
        .attr('transform', `translate(0, ${this.title.sub.y})`)
        .attr('font-size', this.title.sub.tSize).attr('fill', this.title.sub.tColor)
        .text('Mechanical Completion')
      }

      // draw toggle Button
      this.gmx_toggleButton(
        table, 
        {
          variable: 'toggle', 
          id: 'TOG',
          x: 750, y: 38, width: 30, height: 14, tSize:9, radius: 4,
          title: '',
          cColor: '#fff',
          on: {value: 'A',bColor: '#EBE840',tColor: '#333',},
          off: {value: 'B',bColor: '#7EBA45',tColor: '#fff',}      
        },
        this.toggle_action
      )
  

      // Header
      let head = table
      .append('g')
      .attr('transform', `translate(0, ${this.table.y})`)

      this.columns.forEach((d,i)=> {
        if(d.group && d.group != 'L') {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 17 + 11*0.35)
          .attr('font-size', 11).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.group)
        } 
        if(i==0 || i==8){
          head
          .append('text')
          .attr('x', d.mx).attr('y', 26 + 11*0.35)
          .attr('font-size', 11).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        } else {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 37 + 9*0.35)
          .attr('font-size', 9).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        }
        
        if(d.group =='L') this.gmx_Line(head, d.ex, d.ex, 5,  247,  '#E0E0DF', .5, 1)
      })

      this.gmx_Line(head, this.columns[1].sx, this.table.width - this.columns[8].width, 28,  28, '#E0E0DF', .5, 1)
      this.gmx_Line(head, 0, this.table.width, 6,   6,   '#bcbcbc', .5, 1)
      this.gmx_Line(head, 0, this.table.width, 47,  47,  '#bcbcbc', .5, 1)
      this.gmx_Line(head, 0, this.table.width, 247, 247, '#bcbcbc', .5, 1)
    },

    
  }
}